// Dimensions and padding etc.
export const toPixels = (input: number) => `${input}px`;

export const appBarHeight = 64;

export const fabPadding = {
    mobileY: 24,
    mobileX: 20,
    desktopY: 24,
    desktopX: 24,
};

export enum Platform {
    DESKTOP = 'desktop',
    MOBILE = 'mobile',
    TABLET = 'tablet',
}

// Mobile : below 'sm'
const mobilePortraitWidth = '100%';
const mobileLandscapeWidth = '100%';

// Tablet : 'sm' to 'lg'
const tabletPortraitWidth = '460px';
const tabletLandscapeWidth = '460px';

// Desktop : above 'lg'
const desktopWidth = '460px';

export function getDrawerWidth(platform: Platform, portrait: boolean) {
    switch (platform) {
        case Platform.MOBILE:
            return portrait ? mobilePortraitWidth : mobileLandscapeWidth;
        case Platform.TABLET:
            return portrait ? tabletPortraitWidth : tabletLandscapeWidth;
        case Platform.DESKTOP:
            return desktopWidth;
    }
}
